import React from 'react';
import { AskingBidValue } from 'components/project/ClerkScreen';
import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import { useSellerAction } from 'hooks';
import { Container, AskingBidLabel, OkayToSell } from './Styles';

const AskingBid = ({ disabled }) => {
  const { okayToSell, doNotSell, sellerMessage, isTake } = useSellerAction();

  return (
    <Container
      isTake={isTake}
      doNotSell={doNotSell}
      okayToSell={okayToSell}
      disabled={disabled}
    >
      <AskingBidLabel>Asking Bid</AskingBidLabel>
      <AskingBidValue />
      {sellerMessage && (
        <OkayToSell okayToSell={okayToSell} isTake={isTake}>
          ({sellerMessage})
        </OkayToSell>
      )}
    </Container>
  );
};

AskingBid.propTypes = {
  disabled: PropTypes.bool.isRequired,
};

export default observer(AskingBid);
